'use client';

import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import { useBannerAdOpen } from '@wt/game/providers/bannerAdOpen/BannerAdOpenProvider';
import {
  destroyBannerAd,
  refreshBannerAd,
} from '@wt/shared/hooks/useAds/useAds';
import { getSiteMode } from '@wt/utilities/siteMode';
import { usePathname } from 'next/navigation';
import React, { useMemo } from 'react';

import { RemoveAdsBannerTab } from './RemoveAdsBannerTab';

const BannerAd = () => {
  const { adOpen, setAdOpen } = useBannerAdOpen();
  const pathname = usePathname();

  if (pathname.includes('admin')) {
    return <></>;
  }

  const adSize = useMemo(() => {
    return adOpen ? 'h-[90px]' : 'h-0';
  }, [adOpen]);

  const top = useMemo(() => {
    return adOpen ? 'top-[90px]' : 'top-0';
  }, [adOpen]);

  return (
    <div className="bg-base-100 sticky top-0 z-50 flex w-full max-w-full flex-col">
      <div className="bg-base-100 relative flex w-full flex-col items-start justify-start">
        <div
          className={`bg-base-200 flex w-full shrink flex-col items-center justify-center pb-1 ${adSize}`}
        >
          <div
            className={`bg-base-200 flex w-full shrink items-center justify-center overflow-hidden ${adSize}`}
          >
            {getSiteMode() != 'whentaken-movies' && (
              <div id="adngin-top_banner-0"></div>
            )}
            {getSiteMode() == 'whentaken-movies' && (
              <div id="adngin-top-0"></div>
            )}
          </div>
        </div>
        <div
          className={`bg-base-200 absolute left-0 ${top} flex h-4 w-8 shrink items-center justify-center overflow-hidden rounded-br-md`}
        >
          <button
            className={`duration-500 ${adOpen ? 'rotate-180' : 'rotate-0'}`}
            onClick={() => {
              adOpen ? destroyBannerAd() : refreshBannerAd();
              setAdOpen(!adOpen);
            }}
          >
            <ExpandMoreRoundedIcon />
          </button>
        </div>
        <RemoveAdsBannerTab top={top} />
      </div>
    </div>
  );
};

export default BannerAd;
